<template>
    <el-dialog class="scoped-interivew-email" :title="senderTitle" :visible.sync="dialogFormVisible"
               v-if="params"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
        <div class="editView" v-show="!isPreview" :key="renderKey">
            <div
                v-if="params.userAttributes === 4"
                style="width:85%;margin: 0px auto 20px;"
            >
                <el-table :data="supplierList">
                    <el-table-column label="供应商" width="100" prop="supplierName"></el-table-column>
                    <el-table-column label="候选人数量" width="80">
                        <template slot-scope="scope">{{scope.row.rpIdList.length}}</template>
                    </el-table-column>
                    <el-table-column label="对接人(点击名字标签可发送给该对接人)">
                        <template slot-scope="scope">
                            <el-tag
                                v-for="(item, index) in scope.row.contactList"
                                :key="index"
                                class="user-tag"
                                :class="{'disabled': item.disabled === true}"
                                @click.native="togglerUserActive(item)"
                            >{{item.name}}({{item.email}})</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                            <a href="javascript:;" @click="previewEmailSupplier(scope.row)">预览</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-form :model="form" v-if="baseData" class="form-beauty">
                <el-form-item label="选择模板" :label-width="formLabelWidth">
                    <el-select @change="selectedTpl" v-model="selectTpl" placeholder="请选择模板">
                        <el-option v-for="item in baseData.list" :key="item.id" :value="item.id"
                                   :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="面试阶段" :label-width="formLabelWidth"
                              v-if="interviewArrangeForms.length && !isMultiEmail && isInterviewPhase && showInterviewPhase">
                    <el-checkbox class="mr-20" :indeterminate="isIndeterminate" v-model="checkAllParse"
                                 @change="handleCheckAllChange">全选
                    </el-checkbox>
                    <el-checkbox-group v-model="filterIntViewArrIds" @change="handleCheckedPharseChange"
                                       style="display: inline-block">
                        <el-checkbox v-for="item in interviewArrangeForms" :key="item.id" :label="item.id">
                            {{item.turnName}}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item
                    v-if="params.userAttributes !== 4"
                    label="收件人"
                    :label-width="formLabelWidth"
                >
                    <user-group v-if="params.userAttributes === 2" ref="sendEmail" v-model="form.sendEmail"
                                :allowEmail="true" :cacheOptions="interviewerUsers"></user-group>
                    <div v-else>
                        <div v-if="isMultiEmail">
                            <el-tag v-for="(item, index) in baseData.resumePositionList" :key="index" class="mr-5"
                                    @click.native="previewEmail(item.id, index)">
                                {{item.resume.name}}（{{item.resume.email}}）<b>【预览】</b>
                            </el-tag>
                        </div>
                        <div v-else>
                            <el-tag v-for="(item, index) in baseData.resumePositionList" :key="index" class="mr-5">
                                {{item.resume.name}}（{{item.resume.email}}）
                            </el-tag>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="抄送人" :label-width="formLabelWidth">
                    <user-group ref="ccList" v-model="form.ccList" :cacheOptions="ccUsers"
                                :allowEmail="true"></user-group>
                </el-form-item>
                <el-form-item label="邮件标题" :label-width="formLabelWidth">
                    <el-input v-model.trim="form.name" auto-complete="off" :maxlength="200"></el-input>
                </el-form-item>
                <el-form-item label="附件" :label-width="formLabelWidth">
                    <file-upload
                            class="upload-desc"
                            :action="`${$axios.defaults.baseURL}/payment/template/fileInsert.api`"
                            v-model="fileList">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </file-upload>
                </el-form-item>
                <el-form-item label="邮件内容" :label-width="formLabelWidth">
                    <div class="quickTool">
                        <el-tag v-for="(item, key) in baseData.mailHolder"
                                @click.native="$refs.editor.addAfterCursor(item.value)"
                                icon="el-icon-plus"
                                :key="key"
                                size="small">{{item.text}}
                        </el-tag>
                    </div>
                    <vueditor v-model="form.contentCode" ref="editor"></vueditor>
                </el-form-item>
            </el-form>
        </div>
        <div class="previewView" v-if="isPreview">
            <div style="border-bottom: 1px solid #ddd;">
                <p style="font-size: 16px;font-weight: bold;">邮件标题：{{form.name}}</p>
                <p>收件人：<span v-for="(item, index) in interviewerUsers"
                             :key="item.id">{{item.name}}<span v-if="index < interviewerUsers.length-1">、</span></span>
                </p>
                <p>抄送人：<span v-for="(item, index) in ccUsers"
                             :key="item.id">{{item.name}}<span v-if="index < ccUsers.length-1">、</span></span></p>
            </div>
            <p v-if="form.hrAttachIds.length || form.mailAttachInfos.length">
                附件：
                <span v-if="form.hrAttachIds.length">
                        <span class="mr-5" v-for="(item, index) in getAttachItems" :key="item.id">{{item.name}}<span
                                v-if="index < getAttachItems.length-1">、</span></span></span>
                <span v-if="form.mailAttachInfos.length">
                        <span class="mr-5" v-for="(item, index) in form.mailAttachInfos" :key="item.id">{{item.fileName}}<span
                                v-if="index < form.mailAttachInfos.length-1">、</span></span></span></p>
            <div style="border-top: 1px solid #ddd;">
                <div v-html="form.content"></div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <el-button
                type="success"
                class="left"
                @click.native.stop="previewAll"
                v-if="showPreviewBtn"
            >预 览</el-button>
            <el-button @click="dialogFormVisible = false" v-if="!isPreview">取 消</el-button>
            <el-button type="success" class="left" @click="toEditView" v-if="isPreview">返 回</el-button>
            <el-button
                v-if="showSendBtn"
                type="primary"
                @click="sendEmailAll"
            >发 送</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import UserSearch from 'components/userSelect/searchDownList'
    import UserGroup from 'components/userSelect/userSelect'
    import FileUpload from 'components/fileUpload'
    import {dateFormat} from 'modules/tools'
    import axios from 'axios'
    import _ from 'underscore'
    import Vueditor from 'components/vueditor'
    // userAttributes 1-应聘者  2-面试官
    export default {
        components: {
            Vueditor, UserSearch, FileUpload, UserGroup
        },
        data () {
            return {
                dialogFormVisible: false,
                renderKey: 1,
                ccUsers: [],                // 抄送人对象
                params: null,
                isPreview: false,
                showInterviewPhase: true, // 是否展示面试阶段字段
                checkAllParse: true,
                interviewArrangeForms: [],
                filterIntViewArrIds: [],
                interviewerUsers: [],       // 收件人对象
                allInterviewsIds: [],
                supplierList: [], // 供应商邮件发送时，供应商列表
                isIndeterminate: false,
                form: {
                    name: '',
                    sendEmail: '',
                    ccList: '',
                    delivery: false,
                    mailAttachInfos: [],
                    hrAttachIds: [],
                    content: '',
                    contentCode: ''
                },
                fileList: [],
                selectTpl: '',
                baseData: null,
                formLabelWidth: '120px',
                uploadData: {
                    code: '',
                    fileType: 'upload'
                }
            }
        },
        methods: {
            updateData (data) {
                this.form.contentCode = data
            },
            handleCheckAllChange (val) {
                this.filterIntViewArrIds = val ? this.allInterviewsIds : []
                this.isIndeterminate = false
            },
            handleCheckedPharseChange (value) {
                let checkedCount = value.length
                this.checkAllParse = checkedCount === this.interviewArrangeForms.length
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.interviewArrangeForms.length
            },
            selectedTpl (id) {
                let data
                if (_.isObject(id)) {
                    data = id
                } else {
                    data = this.baseData.list.filter(item => item.id === id)[0]
                }
                if (data) {
                    Object.assign(this.form, data, {
                        name: data.title,
                        contentCode: data.content,
                        hrAttachIds: data.hrattachids === '' ? [] : data.hrattachids.split(',')
                    })
                    this.$refs.editor && this.$refs.editor.resetContent(data.content)
                }
            },
            toEditView () {
                this.isPreview = false
            },
            initDataBeforeShow (params) {
                axios.post('/resumePosition/mailSend/mailList.api', params).then(res => {
                    this.baseData = res.result
                    this.baseData.resumePositionList = params.resumePositionList
                    this.interviewArrangeForms = params.selecteds
                    let ids = [], interviewUsers = [],
                        paramsInterviewIds = this.params.interviewIds ? this.params.interviewIds.split(',') : []
                    this.interviewArrangeForms.forEach(item => {
                        ids.push(item.id)
                        interviewUsers = interviewUsers.concat(item.interviewerUsers)
                    })
                    interviewUsers = _.uniq(interviewUsers, item => item.id)
                    this.filterIntViewArrIds = ids
                    this.allInterviewsIds = ids
                    this.checkAllParse = true
                    this.isIndeterminate = false
                    if (this.isForInterviewers) {
                        this.interviewerUsers = interviewUsers
                        this.form.sendEmail = _.pluck(this.interviewerUsers, 'id').join(',')
                        this.$refs.sendEmail && this.$refs.sendEmail.setDefaultValue(this.interviewerUsers, this.form.sendEmail)
                    }
                    this.setMultiInterviewEmailsTpl()
                    this.dialogFormVisible = true
                })

                if (params.userAttributes === 4) {
                    axios.post('/resumePosition/supplierNotify.api', {
                        rpIds: params.ids
                    }).then(res => {
                        if (res.status === true) {
                            this.supplierList = res.result.supplierInfo || []
                            this.supplierList.forEach(supplier => {
                                if (supplier.contactList && supplier.contactList.length) {
                                    supplier.contactList.forEach(item => {
                                        this.$set(item, 'disabled', true)
                                    })
                                }
                            })
                        }
                    })
                }
            },
            setMultiInterviewEmailsTpl () {
                if (this.isMultiEmail && this.isForInterviewers) {
                    this.selectedTpl({
                        name: '【专业面试安排确认】',
                        type: 'interviewTpl',
                        hrattachids: '',
                        content: 'Hi 面试官，我们安排了以下人选进行面试，如果有其他问题可以与我联系。 <br> [!--interview_table--]  <br> [!--conferenceLinks--]  <br>'
                    })
                    this.baseData.mailHolder = [{
                        value: '[!--interview_table--]',
                        text: '面试安排表格（面试官）'
                    }, {
                        value: '[!--conferenceLinks--]',
                        text: '会议链接表格'
                    }]
                }
            },
            show (params) {
                console.log(params)
                this.params = params
                this.isPreview = false
                this.selectTpl = ''
                this.ccUsers = []
                this.form.name = ''
                // 清空收件人信息
                this.form.sendEmail = ''
                this.$refs.sendEmail && this.$refs.sendEmail.reset()
                // 清空抄送人信息
                this.$refs.ccList && this.$refs.ccList.$refs.select && this.$refs.ccList.$refs.select.reset()
                this.form.delivery = false
                this.form.hrAttachIds = []
                this.fileList = []
                this.form.content = ''
                this.form.contentCode = ''
                this.showInterviewPhase = typeof params.showInterviewPhase !== 'undefined'
                    ? params.showInterviewPhase : true
                this.renderKey++
                this.initDataBeforeShow(params)
                this.$refs.editor && (this.$refs.editor.lastRange = null)
            },
            checkForm () {
                if (!this.form.name) {
                    this.$message({
                        message: '邮件标题不能为空',
                        type: 'warning'
                    })
                    return false
                }
                if (this.form.contentCode === '') {
                    this.$message({
                        message: '邮件内容不能为空',
                        type: 'warning'
                    })
                    return false
                }
                if (this.params.userAttributes === 2) {
                    if (this.filterIntViewArrIds.length === 0) {
                        this.$message({
                            message: '面试阶段不能为空',
                            type: 'warning'
                        })
                        return false
                    }
                }
                return true
            },
            getUserEmailInfo () {
                this.interviewerUsers = []
                this.baseData.resumePositionList.forEach(item => {
                    this.interviewerUsers.push({
                        id: item.resume.email,
                        name: item.resume.name
                    })
                })
                return _.pluck(this.interviewerUsers, 'id').join(',')
            },
            generateSupplierReceiveList (supplier) {
                let rpIds = []
                this.interviewerUsers = []

                supplier.contactList.filter(contact => {
                    return !contact.disabled
                }).forEach(contact => {
                    this.interviewerUsers.push({
                        id: contact.email,
                        name: contact.name
                    })
                })

                if (this.interviewerUsers.length === 0) {
                    return false
                }

                supplier.rpIdList.forEach(rpId => {
                    const resumePosition = this.baseData.resumePositionList.find(rpl => {
                        return rpl.rpId == rpId
                    }) || {}

                    const arrangeIdList = (resumePosition.list || []).map(item => item.id)
                        .filter(aId => this.filterIntViewArrIds.includes(aId))
                    rpIds.push({ rpId, arrangeIdList })
                })

                return {
                    emails: this.interviewerUsers.map(i => i.id).join(','),
                    rpIds
                }
            },
            previewEmailSupplier (row) {
                if (this.checkForm() === false) {
                    return false
                }

                const filteredSupplierList = row
                    ? this.supplierList.filter(supplier => {
                        return supplier.supplierCode === row.supplierCode
                    }) : this.supplierList
                
                const receiver = this.generateSupplierReceiveList(filteredSupplierList[0])
                if (!receiver) {
                    this.$message({
                        message: '供应商对接人不能为空',
                        type: 'warning'
                    })
                    return false
                }

                const receiveList = [receiver]

                this.ccUsers = this.$refs.ccList.getSelected()

                const url = '/resumePosition/mailSend/lookSendMail.api'
                
                const params = {
                    name: this.form.name,
                    content: this.form.contentCode + this.getSign(),
                    userAttributes: 4,
                    receiveList,
                    attachList: this.fileList.map(file => ({
                        md5: file.md5,
                        fileId: file.fileId
                    })),
                    ccList: this.ccUsers.map(c => c.id).join(',')
                }

                axios.post(url, params, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    transformRequest: data => JSON.stringify(data)
                }).then(res => {
                    this.form.content = res.result.bean
                    this.isPreview = true
                }).catch(function () {
                })
            },
            previewEmail (id, index) {
                if (this.checkForm() === false) {
                    return false
                }
                if (this.params.userAttributes === 2) {
                    this.interviewerUsers = this.$refs.sendEmail.getSelected()
                } else {
                    this.interviewerUsers = []
                    this.baseData.resumePositionList.forEach(item => {
                        this.interviewerUsers.push({
                            id: item.resume.email,
                            name: item.resume.name
                        })
                    })
                }
                this.ccUsers = this.$refs.ccList.getSelected()
                // 给表单设值
                if (this.params.userAttributes === 1) {
                    this.form.sendEmail = this.getUserEmailInfo()
                } else {
                    this.form.sendEmail = _.pluck(this.interviewerUsers, 'id').join(',')
                }
                this.form.ccList = _.pluck(this.ccUsers, 'id').join(',')
                let params = {
                    name: this.form.name,
                    resumePositionId: id || (this.params.ids + ''),
                    userAttributes: this.params.userAttributes,
                    interviewId: this.params.interviewIds.split(',')[index || 0],
                    content: this.form.contentCode + this.getSign(),
                    sendEmail: this.form.sendEmail,
                    ccUsers: this.form.ccUsers
                }
                let url = '/resumePosition/mailSend/lookMail.api'
                if (this.isForInterviewers && this.isMultiEmail) {
                    url = '/resumePosition/mailSend/lookMutliMail.api'
                    params.filterIntViewArrIds = this.allInterviewsIds.join(',')
                    params.interviewId = undefined
                    params.resumePositionId = undefined
                    params.id = undefined
                    params.ccList = this.form.ccList
                } else {
                    params.filterIntViewArrIds = this.filterIntViewArrIds.length ? this.filterIntViewArrIds.join(',') : undefined
                }
                axios.post(url, params).then(res => {
                    this.form.content = res.result.bean
                    this.isPreview = true
                }).catch(function () {
                })
            },
            previewAll () {
                if (this.params.userAttributes === 4) {
                    this.previewEmailSupplier(null)
                } else {
                    this.previewEmail(null)
                }
            },
            sendEmailSupplier () {
                if (this.checkForm() === false) {
                    return false
                }

                const receiveList = this.supplierList.map(supplier => {
                    return this.generateSupplierReceiveList(supplier)
                }).filter(Boolean)

                if (receiveList.length === 0) {
                    this.$message({
                        message: '供应商对接人不能为空',
                        type: 'warning'
                    })
                    return false
                }

                this.ccUsers = this.$refs.ccList.getSelected()

                const url = '/resumePosition/mailSend/sendMailToSupplier.api'
                const params = {
                    name: this.form.name,
                    content: this.form.contentCode + this.getSign(),
                    userAttributes: 4,
                    receiveList,
                    attachList: this.fileList.map(file => ({
                        md5: file.md5,
                        fileId: file.fileId
                    })),
                    ccList: this.ccUsers.map(c => c.id).join(',')
                }

                axios.post(url, params, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    transformRequest: data => JSON.stringify(data),
                    'X-showMessage': true
                }).then(res => {
                    this.dialogFormVisible = false
                    this.$emit('sendSuccess', this.params)
                }).catch(function () {
                })
            },
            sendEmail () {
                if (this.checkForm() === false) {
                    return false
                }
                let url = '/resumePosition/mailSend/sendMail.api'
                if (this.isForInterviewers && this.isMultiEmail) {
                    url = '/resumePosition/mailSend/sendMutliMail.api'
                } else if (this.isForEmployee && this.isMultiEmail) {
                    url = '/resumePosition/mailSend/sendMutliMailForResume.api'
                }
                if (this.params.userAttributes === 2) {
                    // 预览页面this.$refs.sendEmail为null
                    if (this.$refs.sendEmail) {
                        this.interviewerUsers = this.$refs.sendEmail.getSelected()
                        this.form.sendEmail = _.pluck(this.interviewerUsers, 'id').join(',')
                    }
                } else {
                    this.form.sendEmail = this.getUserEmailInfo()
                }
                // 预览页面this.$refs.ccList为null
                if (this.$refs.ccList) {
                    this.ccUsers = this.$refs.ccList.getSelected()
                    this.form.ccList = _.pluck(this.ccUsers, 'id').join(',')
                }
                let params = {
                    resumePositionId: this.params.ids,
                    userAttributes: this.params.userAttributes,
                    interviewId: this.params.interviewIds.split(',')[0],
                    name: this.form.name,
                    mailAttachInfos: JSON.stringify(this.form.mailAttachInfos),
                    hrAttachIds: this.form.hrAttachIds.join(','),
                    filemd5Id: this.getFileData(),
                    attaches: JSON.stringify(this.fileList),
                    content: '<div style="font-family:微软雅黑;">' + this.form.contentCode + this.getSign() + '</div>',
                    ccList: this.form.ccList,
                    sendEmail: this.form.sendEmail
                }
                if (this.isForInterviewers && this.isMultiEmail) {
                    params.filterIntViewArrIds = this.allInterviewsIds.join(',')
                    params.interviewId = undefined
                    params.resumePositionId = undefined
                } else if (this.isForEmployee && this.isMultiEmail) {
                    params.interviewIds = this.params.interviewIds
                    params.ids = this.params.ids
                    params.resumePositionId = undefined
                    params.interviewId = undefined
                } else {
                    params.filterIntViewArrIds = this.filterIntViewArrIds.length ? this.filterIntViewArrIds.join(',') : undefined
                }
                // 给表单设置
                axios.post(url, params, {
                    'X-showMessage': true
                }).then(res => {
                    this.dialogFormVisible = false
                    this.$emit('sendSuccess', this.params)
                })
            },
            sendEmailAll () {
                if (this.params.userAttributes === 4) {
                    this.sendEmailSupplier()
                } else {
                    this.sendEmail()
                }
            },
            getFileData () {
                let data = []
                this.form.hrAttachIds.forEach(id => {
                    let item = _.findWhere(this.baseData.hrAttachList, {id: id})
                    item && data.push(['hr', item.md5, item.fileId, item.attachName].join(','))
                })
                return data.join(';')
            },
            getSign () {
                const userInfo = this.$store.state.user
                const needUserInfo = this.params.userAttributes !== 1
                
                let html = `<div style="color: #999;margin-top: 50px;font-family: 微软雅黑;font-size: 14px;">
                    <p style="margin: 5px 0;border-bottom: 1px solid #999;width: 300px;">${dateFormat(new Date())}</p>`
                if (needUserInfo) {
                    html += `<p style="margin:5px 0;">发件人：${userInfo.name || '-'}</p>
                        <p style="margin:5px 0;">部门：${userInfo.deptName || '-'}</p>
                        <p style="margin:5px 0;">POPO：${userInfo.email || '-'}</p>`
                }
                html += `</div>`

                return html
            },
            togglerUserActive (item) {
                this.$nextTick(() => {
                    item.disabled = !item.disabled
                })
            },
            // handlePreview (file) {
            //     if (file.preUrl) {
            //         window.open(file.preUrl)
            //     } else {
            //         this.$message.warning('该文件不支持预览')
            //     }
            // },
            // handleFileSuccess (res, file) {
            //     if (res.status) {
            //         this.fileList.push(res.result)
            //     } else {
            //         this.$message.error(res.desc || '上传失败')
            //     }
            // },
            // handleFileRemove (file, fileList) {
            //     this.fileList = fileList
            // }
        },
        computed: {
            getAttachItems () {
                let ids = this.form.hrAttachIds,
                    res = []
                this.baseData.hrAttachList.forEach(item => {
                    if (ids.indexOf(item.id) > -1) {
                        res.push(item)
                    }
                })
                return res
            },
            senderTitle () {
                if (this.isPreview) {
                    return '邮件预览'
                }

                if (this.params && this.params.userAttributes) {
                    const map = {
                        1: '通知应聘者',
                        2: '通知面试官',
                        4: '供应商邮件发送'
                    }
                    return map[this.params.userAttributes] || ''
                }
            },
            isForInterviewers () {
                return this.params.userAttributes === 2
            },
            isForEmployee () {
                return this.params.userAttributes === 1
            },
            showPreviewBtn () {
                if (this.params.userAttributes === 4) {
                    return false
                } else if (this.isForInterviewers) {
                    return !this.isPreview
                } else {
                    return !this.isPreview && !this.isMultiEmail
                }
            },
            isInterviewPhase () {
                return this.params.phase !== '0' && this.params.phase !== '10'
            },
            isMultiEmail () {
                if (this.params) {
                    let ids = this.params.ids
                    return ids.split(',').length > 1
                } else {
                    return false
                }
            },
            showSendBtn () {
                if (this.params.userAttributes === 4) {
                    return !this.isPreview
                }
                return true
            }
        }
    }
</script>
<style lang="scss">
    .scoped-interivew-email {
        .user-tag {
            cursor: pointer;
            margin:5px;
        }
        .user-tag.disabled {
            text-decoration: line-through;
            background: #dddddd;
            color: #fff;
            border-color: transparent;
        }
        .previewView {
            overflow : auto;
            height   : 520px;
        }
        .quickTool {
            .el-tag {
                cursor       : pointer;
                margin-right : 5px;
            }
        }
        .dialog-footer {
            button {
                width : 150px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// interviewerEmailDialog.vue?6dd3e54c